import store from '@/store';
import api from '@/services/api';

export function getUserDeviceInfo() {
  const userDeviceInfo = store.getters['userBehavior/getUserDeviceInfo'];
  userDeviceInfo.url = window.location.href;
  store.dispatch('userBehavior/updateUserDeviceInfo', userDeviceInfo);
  return store.getters['userBehavior/getUserDeviceInfo'];
}

export async function addELK(eventName, eventInfo = {}) {
  const userDeviceInfo = getUserDeviceInfo();

  const logContent = {
    processId: sessionStorage.getItem('sessionID'),
    os: userDeviceInfo.operatingSystem,
    device: userDeviceInfo.device,
    appId: 78,
    platform: 3,
    version: null,
    eventName,
    eventTime: Date.now(),
    userEvents: [
      {
        name: eventName,
        duration: 0,
        time: Date.now(),
        info: {
          deviceID: localStorage.getItem('MachineId'),
          page_title: userDeviceInfo.title,
          page_url: userDeviceInfo.url,
          userAgent: navigator.userAgent,
          ...eventInfo,
        },
      },
    ],
  };

  try {
    await api.addElkLog(logContent);
  } catch (err) {
    console.log(err);
  }
}
